import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";
import ArrowRight from "~/components/icons/arrow-right-eon";
import { useLanguage } from "~/translations/loader/use-language";

export interface TeaserCardProps {
  href?: string;
  imageSrc: string;
  title?: string;
}

export function TeaserCard({ imageSrc, href, title }: TeaserCardProps) {
  const t = useLanguage();

  return (
    <li>
      <CustomLink
        blank
        className="group flex h-full flex-col text-white"
        href={href || "#"}
      >
        <div className="flex h-full flex-col text-white">
          <div className="relative">
            <CustomImage
              alt={title}
              className="aspect-[7/5] w-full object-cover object-center"
              height={300}
              sizes="(max-width: 768px) 100vw, 33vw"
              src={imageSrc}
              width={400}
            />
          </div>
          <div className="flex flex-grow flex-col justify-between bg-primary p-6 md:p-4 lg:p-6 xl:p-8">
            {title && (
              <p
                className="font-medium text-3xl md:text-lg lg:text-xl xl:text-3xl"
                data-source="lc"
              >
                {title}
              </p>
            )}

            <p
              className="flex items-center gap-x-2 pt-4 text-2xl group-hover:underline md:text-base lg:pt-8 lg:text-xl"
              data-source="lc"
            >
              <ArrowRight />
              {t.teaserbar_linkText}
            </p>
          </div>
        </div>
      </CustomLink>
    </li>
  );
}
